import Vue from 'vue'
import Router from 'vue-router'

import ContainerDefault from '../containers/Default.vue'
import IndexPropostas from '../views/propostas/Index.vue'
import NovaProposta from '../views/propostas/Nova.vue'
import IndexLogin from '../views/login/Index.vue'
import ViewProposta from '../views/propostas/View.vue'
import EditarProposta from '../views/propostas/Editar.vue'
import IndexManutencao from '../views/login/Index_manutencao.vue'

import IndexConfigContas from '../views/configuracoes/contas/Index.vue'
import simulacaoTerceiro from '../views/terceiros/index.vue'
import IndexVendedores from '../views/vendedores/Index.vue'

Vue.use(Router);
var manutencao = false;
export default new Router({
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: IndexLogin
        },
        {
            path: '',
            redirect: '/erro404',
            component: ContainerDefault,
            children: [
                {
                    path: '/',
                    name: 'Inicio',
                    component: !manutencao? IndexPropostas : IndexManutencao
                },
                {
                    path: '/propostas',
                    component: {
                        render (c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            name: 'IndexPropostas',
                            component:  !manutencao? IndexPropostas : IndexManutencao
                        },
                        {
                            path: 'nova',
                            name: 'NovaProposta',
                            component:  !manutencao?  NovaProposta : IndexManutencao
                        },
                        {
                            path: ':id/:origem/editar',
                            name: 'EditarProposta',
                            component: !manutencao?  EditarProposta : IndexManutencao
                        },
                        {
                            path: ':id/:origem/visualizar',
                            name: 'ViewProposta',
                            component: !manutencao? ViewProposta : IndexManutencao
                        },

                    ]
                },

                {
                    path: '/simulacao',
                    component: {
                        render (c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: ':token/:marca/:modelo/:ano/simular',
                            name: 'IndexSimulacao',
                            component:  simulacaoTerceiro
                        },
                       

                    ]
                },
                {
                    path: '/configuracoes',
                    component: {
                        render (c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: 'contas',
                            name: 'IndexConfigContas',
                            component: !manutencao? IndexConfigContas :  IndexManutencao
                        }
                    ]
                },
                {
                    path: '/vendedores',
                    component: {
                        render (c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            name: 'IndexVendedores',
                            component: !manutencao? IndexVendedores :  IndexManutencao
                        }
                    ]
                }
            ]
        }
    ], 
    
})



// WEBPACK FOOTER //
// ./src/router/index.js